if (!customElements.get('bt-withdrawal-form')) {
  class BtWithdrawalForm extends HTMLElement {
    connectedCallback() {
      // Defer so children are available regardless of when the script runs
      setTimeout(() => this._init(), 0);
    }

    _init() {
      this._nonceUrl  = this.dataset.nonceUrl  || '';
      this._submitUrl = this.dataset.submitUrl || '';
      this._T = {
        success:   this.dataset.tSuccess,
        rate:      this.dataset.tRate,
        loadError: this.dataset.tLoadError,
        genError:  this.dataset.tGenError,
        reload:    this.dataset.tReload,
      };

      this._form     = this.querySelector('form');
      if (!this._form) { console.warn('bt-withdrawal-form: no <form> found'); return; }

      this._btn      = this._form.querySelector('button[type="submit"]');
      this._msgBox   = this._form.querySelector('.bt-withdrawal__msg');
      this._acceptCb = this._form.querySelector('[name="accept"]');
      this._nonce    = null;

      if (this._acceptCb) {
        this._acceptCb.addEventListener('change', () => this._syncBtn());
      }
      this._form.addEventListener('submit', this._onSubmit.bind(this));
      this._syncBtn(); // set initial disabled state before nonce loads
      this._loadNonce();
    }

    _syncBtn() {
      const accepted = !this._acceptCb || this._acceptCb.checked;
      const nonceOk  = !this._nonceUrl || !!this._nonce;
      this._btn.disabled = !nonceOk || !accepted;
    }

    _loadNonce() {
      if (!this._nonceUrl) return;
      this._btn.disabled = true;
      fetch(this._nonceUrl, { method: 'GET', credentials: 'omit' })
        .then((r) => (r.ok ? r.json() : Promise.reject()))
        .then((d) => {
          this._nonce = d && d.nonce;
          this._syncBtn();
        })
        .catch(() => {
          this._btn.disabled = true;
          this._showMsg(this._T.loadError, false);
        });
    }

    _onSubmit(e) {
      e.preventDefault();
      const name  = this._form.full_name.value.trim();
      const email = this._form.email.value.trim();
      const order = this._form.order_number.value.trim();
      const okN   = name.length > 0;
      const okE   = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      const okO   = /^[A-Za-z0-9#\-]{1,32}$/.test(order);

      const accepted = !this._acceptCb || this._acceptCb.checked;

      this._setFieldError('full_name', !okN);
      this._setFieldError('email', !okE);
      this._setFieldError('order_number', !okO);
      if (!okN || !okE || !okO || !accepted) return;

      if (!this._nonce) { this._showMsg(this._T.reload, false); return; }

      this._btn.disabled = true;
      this._hideMsg();

      fetch(this._submitUrl, {
        method: 'POST',
        credentials: 'omit',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nonce:        this._nonce,
          full_name:    name,
          email:        email,
          order_number: order,
          reason:       this._form.reason.value.trim(),
          company:      this._form.company.value,
        }),
      })
        .then((r) => {
          if (r.status === 429) { this._showMsg(this._T.rate, false); return; }
          return r.json()
            .catch(() => ({}))
            .then(() => { this._form.reset(); this._showMsg(this._T.success, true); });
        })
        .catch(() => this._showMsg(this._T.genError, false))
        .finally(() => { this._loadNonce(); });
    }

    _setFieldError(name, on) {
      const input = this._form.querySelector(`[name="${name}"]`);
      if (!input) return;
      const errId  = input.getAttribute('aria-describedby');
      const errEl  = errId ? document.getElementById(errId) : null;
      input.setAttribute('aria-invalid', on ? 'true' : 'false');
      if (errEl) errEl.hidden = !on;
    }

    _showMsg(text, ok) {
      this._msgBox.textContent  = text;
      this._msgBox.dataset.state = ok ? 'ok' : 'bad';
      this._msgBox.hidden        = false;
    }

    _hideMsg() {
      this._msgBox.hidden = true;
      delete this._msgBox.dataset.state;
    }
  }

  customElements.define('bt-withdrawal-form', BtWithdrawalForm);
}
